module.exports = "/_next/static/images/nc-564ebcc5c52e386908f780ec4c3fae2e.svg";